export default __webpack_public_path__ + "static/media/mk.5fc07ca0.mp4";